"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/admin_service.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminEventService = void 0;
const admin_service_pb_1 = require("./admin_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.event.v1.AdminEventService
 */
exports.AdminEventService = {
    typeName: "spwn.event.v1.AdminEventService",
    methods: {
        /**
         * 特典ファイルのアップロードURLの取得
         *
         * @generated from rpc spwn.event.v1.AdminEventService.GetSignedUrlForBonusMediaFileUpload
         */
        getSignedUrlForBonusMediaFileUpload: {
            name: "GetSignedUrlForBonusMediaFileUpload",
            I: admin_service_pb_1.AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest,
            O: admin_service_pb_1.AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 特典ファイルのマルチパートアップロードURLの取得
         *
         * @generated from rpc spwn.event.v1.AdminEventService.GetSignedUrlsForBonusMediaFilePartUpload
         */
        getSignedUrlsForBonusMediaFilePartUpload: {
            name: "GetSignedUrlsForBonusMediaFilePartUpload",
            I: admin_service_pb_1.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest,
            O: admin_service_pb_1.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 特典ファイルのマルチパートアップロード完了通知
         *
         * @generated from rpc spwn.event.v1.AdminEventService.CompleteBonusMediaFilePartUpload
         */
        completeBonusMediaFilePartUpload: {
            name: "CompleteBonusMediaFilePartUpload",
            I: admin_service_pb_1.AdminEventServiceCompleteBonusMediaFilePartUploadRequest,
            O: admin_service_pb_1.AdminEventServiceCompleteBonusMediaFilePartUploadResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * アップロードした特典ファイルの情報をイベントに紐づける
         *
         * @generated from rpc spwn.event.v1.AdminEventService.RegisterEventBonusMedia
         */
        registerEventBonusMedia: {
            name: "RegisterEventBonusMedia",
            I: admin_service_pb_1.AdminEventServiceRegisterEventBonusMediaRequest,
            O: admin_service_pb_1.AdminEventServiceRegisterEventBonusMediaResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * イベントに紐づく特典一覧の取得
         *
         * @generated from rpc spwn.event.v1.AdminEventService.GetEventBonusMedia
         */
        getEventBonusMedia: {
            name: "GetEventBonusMedia",
            I: admin_service_pb_1.AdminEventServiceGetEventBonusMediaRequest,
            O: admin_service_pb_1.AdminEventServiceGetEventBonusMediaResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * アップロードした特典ファイルを削除する
         *
         * @generated from rpc spwn.event.v1.AdminEventService.UnregisterEventBonusMedia
         */
        unregisterEventBonusMedia: {
            name: "UnregisterEventBonusMedia",
            I: admin_service_pb_1.AdminEventServiceUnregisterEventBonusMediaRequest,
            O: admin_service_pb_1.AdminEventServiceUnregisterEventBonusMediaResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * アップロードした特典ファイルをチケットに紐づける
         *
         * @generated from rpc spwn.event.v1.AdminEventService.AttachTicketBonusMedia
         */
        attachTicketBonusMedia: {
            name: "AttachTicketBonusMedia",
            I: admin_service_pb_1.AdminEventServiceAttachTicketBonusMediaRequest,
            O: admin_service_pb_1.AdminEventServiceAttachTicketBonusMediaResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * チケットに紐づく特典一覧の取得
         *
         * @generated from rpc spwn.event.v1.AdminEventService.GetTicketBonusMedia
         */
        getTicketBonusMedia: {
            name: "GetTicketBonusMedia",
            I: admin_service_pb_1.AdminEventServiceGetTicketBonusMediaRequest,
            O: admin_service_pb_1.AdminEventServiceGetTicketBonusMediaResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * チケット特典とチケット間の紐づけを解除する
         *
         * @generated from rpc spwn.event.v1.AdminEventService.DetachTicketBonusMedia
         */
        detachTicketBonusMedia: {
            name: "DetachTicketBonusMedia",
            I: admin_service_pb_1.AdminEventServiceDetachTicketBonusMediaRequest,
            O: admin_service_pb_1.AdminEventServiceDetachTicketBonusMediaResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 当選処理を実行する
         *
         * @generated from rpc spwn.event.v1.AdminEventService.StartLotteryWinnerProcess
         */
        startLotteryWinnerProcess: {
            name: "StartLotteryWinnerProcess",
            I: admin_service_pb_1.AdminEventServiceStartLotteryWinnerProcessRequest,
            O: admin_service_pb_1.AdminEventServiceStartLotteryWinnerProcessResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 落選処理を実行する
         *
         * @generated from rpc spwn.event.v1.AdminEventService.StartLotteryLoserProcess
         */
        startLotteryLoserProcess: {
            name: "StartLotteryLoserProcess",
            I: admin_service_pb_1.AdminEventServiceStartLotteryLoserProcessRequest,
            O: admin_service_pb_1.AdminEventServiceStartLotteryLoserProcessResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 当選者を抽出する
         *
         * @generated from rpc spwn.event.v1.AdminEventService.ExtractWinner
         */
        extractWinner: {
            name: "ExtractWinner",
            I: admin_service_pb_1.AdminEventServiceExtractWinnerRequest,
            O: admin_service_pb_1.AdminEventServiceExtractWinnerResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * バウチャーコードを生成する
         *
         * @generated from rpc spwn.event.v1.AdminEventService.CreateVoucherCode
         */
        createVoucherCode: {
            name: "CreateVoucherCode",
            I: admin_service_pb_1.AdminEventServiceCreateVoucherCodeRequest,
            O: admin_service_pb_1.AdminEventServiceCreateVoucherCodeResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * eventRoleの追加に伴うAPI
         *
         * @generated from rpc spwn.event.v1.AdminEventService.AddEventRole
         */
        addEventRole: {
            name: "AddEventRole",
            I: admin_service_pb_1.AdminEventServiceAddEventRoleRequest,
            O: admin_service_pb_1.AdminEventServiceAddEventRoleResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.event.v1.AdminEventService.RemoveEventRole
         */
        removeEventRole: {
            name: "RemoveEventRole",
            I: admin_service_pb_1.AdminEventServiceRemoveEventRoleRequest,
            O: admin_service_pb_1.AdminEventServiceRemoveEventRoleResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.event.v1.AdminEventService.GetEventRoles
         */
        getEventRoles: {
            name: "GetEventRoles",
            I: admin_service_pb_1.AdminEventServiceGetEventRolesRequest,
            O: admin_service_pb_1.AdminEventServiceGetEventRolesResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=admin_service_connect.js.map